import { BaseText, theme } from 'aimo-ui';
import React from 'react';
import { useTranslation } from 'react-i18next';
import styled from 'styled-components/native';
import { StyledWrapper } from 'styles/ContainerStyles';

const Padding = styled.View`
  padding: 0 20px;
`;
const SwishInfo = () => {
  const { t } = useTranslation();
  return (
    <StyledWrapper>
      <Padding>
        <BaseText color={theme.colors.gray300}>
          {t('payment.info.swish')}
        </BaseText>
      </Padding>
    </StyledWrapper>
  );
};

export default SwishInfo;
